import styled from 'styled-components';
export var Container = styled.ul.withConfig({
  displayName: "elements__Container",
  componentId: "glwlsw-0"
})(["list-style:none;font-feature-settings:'tnum';"]);